import React from 'react';

// import { PERMISSIONS } from './app-auth';

const Bundle = ( Component ) => (
    // eslint-disable-next-line react/display-name
    ( props ) => (
        <Component { ...props } />
    )
);

import loadHome from 'bundle-loader?lazy&title=Home!./routes/home/home.jsx';
import loadSearch from 'bundle-loader?lazy&title=Search!./routes/search/search.jsx';

export const routes = {
    home: {
        id: 1,
        title: 'Service Awards Data Admin Studio',
        pattern: '/',
        load: loadHome
    },
    companyRoot: {
        id: 2,
        title: 'Service Awards Data Admin Studio',
        pattern: '/:companyId',
        load: loadHome
    },
    search: {
        id: 3,
        title: 'Service Awards Data Admin Studio - Search',
        pattern: '/:companyId/search',
        load: loadSearch
    },
};

export const routeList = Object.values( routes ).sort( ( a, b ) => ( a?.id || 0 ) - ( b?.id || 0 ) );

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                    :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}

export const replacePatternVars = ( pattern, vars ) => {
    const PATTERN_DELIMITER = '/';
    const pathTokens = ( pattern || '' ).split( PATTERN_DELIMITER ).filter( token => !!token );
    const resolvedTokens = [];

    // Attempt to resolve all tokens in the path
    for ( let i = 0; i < pathTokens.length; i++ ) {
        const token = pathTokens[ i ];
        const PATTERN_PARAM = /^:[a-zA-Z0-9]+/g;
        const paramMatches = ( token || '' ).match( PATTERN_PARAM );

        // If there is a parameter in the token and a matching value, replace the token.
        if ( paramMatches && paramMatches.length > 0 ) {
            const match = paramMatches[ 0 ];
            const paramName = match.substring( 1 );

            const value = vars[ paramName ];
            if ( value !== null && value !== undefined ) {
                resolvedTokens.push( value );
                continue;
            }
        }

        // If the token hasn't already been replaced, leave the token as is.
        resolvedTokens.push( token );
    }
    return PATTERN_DELIMITER + resolvedTokens.join( PATTERN_DELIMITER );
};

export const redirectMiddleware = [
    // redirect from company root to Search page
    ( action, nextRoute, prevRoute ) => {
        const hasMatch = !!nextRoute?.match;
        if ( hasMatch ) {
            const COMPANY_ROOT_PATTERN = routes.companyRoot.pattern;
            const pattern = nextRoute?.match.pattern;

            if ( COMPANY_ROOT_PATTERN === pattern ) {

                const SEARCH_PAGE_PATTERN = routes.search.pattern;
                const redirectPath = replacePatternVars( SEARCH_PAGE_PATTERN, {
                    companyId: nextRoute?.state.params.companyId,
                    ...( nextRoute?.state?.params || {} ),
                } );

                return action.redirect( redirectPath );
            }
        }

        return action.ok();
    },
];